(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-custom-tshirts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript && document.currentScript.closest
      ? document.currentScript.closest('.sv-custom')
      : document.querySelector('.sv-custom');
    if (!section) section = document;

    /* ---- Colour dropdown driven by selected T-shirt style (pending §6.5) ---- */
    var styleSel = section.querySelector('[data-sv-tstyle]');
    var colorSel = section.querySelector('[data-sv-tcolor]');
    if (styleSel && colorSel) {
      function listFor(styleValue) {
        var v = (styleValue || '').toLowerCase();
        var attr = v.indexOf('oversized') > -1 ? 'colorsOversized' : 'colorsRegular';
        return (styleSel.dataset[attr] || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      }
      function fillColors() {
        var prev = colorSel.value;
        var colors = listFor(styleSel.value);
        colorSel.innerHTML = '';
        colors.forEach(function (c) {
          var o = document.createElement('option');
          o.value = c; o.textContent = c;
          if (c === prev) o.selected = true;
          colorSel.appendChild(o);
        });
      }
      styleSel.addEventListener('change', fillColors);
      fillColors();
    }

    /* ---- Artwork picker + preview (pending §6.3 / §6.4) -------------------- */
    var uploader = section.querySelector('[data-sv-upload]');
    if (uploader) {
      var fileInput = uploader.querySelector('[data-sv-file]');
      var dropzone = uploader.querySelector('[data-sv-dropzone]');
      var preview = uploader.querySelector('[data-sv-preview]');
      var thumb = uploader.querySelector('[data-sv-thumb]');
      var nameEl = uploader.querySelector('[data-sv-filename]');
      var removeBtn = uploader.querySelector('[data-sv-file-remove]');
      var note = uploader.querySelector('[data-sv-file-note]');
      var MAX = 10 * 1024 * 1024;
      var okExt = ['png', 'jpg', 'jpeg', 'pdf', 'ai', 'psd'];

      function showNote(msg, isErr) {
        note.hidden = false; note.textContent = msg;
        note.classList.toggle('is-err', !!isErr);
        note.classList.toggle('is-ok', !isErr);
      }
      function reset() {
        if (fileInput) fileInput.value = '';
        preview.hidden = true; thumb.hidden = true; thumb.removeAttribute('src');
        nameEl.textContent = ''; note.hidden = true;
      }
      function handleFile(file) {
        if (!file) return;
        var ext = (file.name.split('.').pop() || '').toLowerCase();
        if (okExt.indexOf(ext) === -1) { showNote('Unsupported format. Use PNG, JPG, PDF, AI or PSD.', true); return; }
        if (file.size > MAX) { showNote('File is too large (max 10 MB). For bigger AI/PSD files, send it on WhatsApp instead.', true); return; }
        nameEl.textContent = file.name + ' · ' + (file.size / 1048576).toFixed(1) + ' MB';
        preview.hidden = false;
        if (/^image\//.test(file.type)) {
          var reader = new FileReader();
          reader.onload = function (e) { thumb.src = e.target.result; thumb.hidden = false; };
          reader.readAsDataURL(file);
        } else { thumb.hidden = true; }
        showNote('Artwork attached. It’ll be emailed to us with your request when you tap “Submit Custom Request”.', false);
      }
      if (fileInput) {
        fileInput.addEventListener('change', function () { handleFile(fileInput.files[0]); });
      }
      if (removeBtn) removeBtn.addEventListener('click', function (e) { e.preventDefault(); reset(); });
      if (dropzone) {
        ['dragenter', 'dragover'].forEach(function (ev) {
          dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.add('is-drag'); });
        });
        ['dragleave', 'drop'].forEach(function (ev) {
          dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.remove('is-drag'); });
        });
        dropzone.addEventListener('drop', function (e) {
          if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
            if (fileInput) { try { fileInput.files = e.dataTransfer.files; } catch (err) {} }
            handleFile(e.dataTransfer.files[0]);
          }
        });
      }
    }

    /* ---- Show success + scroll after FormSubmit redirects back (?sent=1) ---- */
    try {
      if (/[?&]sent=1(&|$)/.test(location.search)) {
        var okMsg = section.querySelector('[data-sv-success]');
        if (okMsg) {
          okMsg.hidden = false;
          okMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (history.replaceState) {
          history.replaceState(null, '', location.pathname + location.hash);
        }
      }
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Split-hero image cross-fade (auto only). */
    function initFade(el) {
      var slides = el.querySelectorAll('.sv-hero__slide');
      if (slides.length < 2 || reduce) return;
      var interval = parseInt(el.getAttribute('data-interval'), 10) || 3000;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, interval);
    }
    document.querySelectorAll('[data-sv-hero-carousel]').forEach(initFade);

    /* Banner carousel — dots, arrows, swipe, autoplay w/ pause on hover/focus. */
    function initBanner(root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('.sv-hero__bslide'));
      if (slides.length < 2) return;
      var dots = Array.prototype.slice.call(root.querySelectorAll('.sv-hero__bdot'));
      var prev = root.querySelector('.sv-hero__bnav--prev');
      var next = root.querySelector('.sv-hero__bnav--next');
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      var cur = 0, timer = null;

      function show(n) {
        n = (n + slides.length) % slides.length;
        if (n === cur) return;
        slides[cur].classList.remove('is-active');
        slides[cur].setAttribute('aria-hidden', 'true');
        if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].removeAttribute('aria-current'); }
        cur = n;
        slides[cur].classList.add('is-active');
        slides[cur].setAttribute('aria-hidden', 'false');
        if (dots[cur]) { dots[cur].classList.add('is-active'); dots[cur].setAttribute('aria-current', 'true'); }
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { if (!reduce && !timer && !document.hidden) timer = setInterval(function () { show(cur + 1); }, interval); }
      function go(n) { show(n); stop(); start(); }

      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(cur - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(cur + 1); });
      dots.forEach(function (d, idx) { d.addEventListener('click', function (e) { e.preventDefault(); go(idx); }); });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });

      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? cur + 1 : cur - 1);
        x0 = null;
      }, { passive: true });

      start();
    }
    document.querySelectorAll('[data-sv-hero-banner]').forEach(initBanner);
  })();

  } catch(e) { console.error(e); }
})();
})();
